import { useDeficiencyDocumentUpload } from "@features/deficiencies/hooks/useDeficiencyDocumentUpload";
import { DEFICIENCY_RESOLUTION_PROOF_UPLOAD_KEY } from "./uploadKeys";

const RESOLUTION_PROOF_DOCUMENT_TYPE = "RESOLUTION_PROOF";

export const RESOLUTION_PROOF_UPLOAD_KEY = DEFICIENCY_RESOLUTION_PROOF_UPLOAD_KEY;

export const useResolveDeficiencyProofUpload = () => {
  const {
    uploadEntries,
    setUploadEntries,
    handleUpload,
    resetUpload,
    uploadedDocumentUrls,
    isUploading,
  } = useDeficiencyDocumentUpload({
    storeKey: RESOLUTION_PROOF_UPLOAD_KEY,
    certificateType: RESOLUTION_PROOF_DOCUMENT_TYPE,
    fallbackFileNamePrefix: "proof",
    errorNotification: {
      titleKey: "deficiencies.notifications.resolve-error-title",
      descriptionKey: "deficiencies.notifications.resolve-error-description",
    },
  });

  return {
    uploadEntries,
    setUploadEntries,
    handleUpload,
    resetUpload,
    uploadedProofUrls: uploadedDocumentUrls,
    isUploading,
  };
};
